import { Text } from "@instacover/ui"
import { createFileRoute } from "@tanstack/react-router"
import { Trans } from "react-i18next"

import { WallGraphic } from "@/components/wall/WallGraphic"
import { IntroContent } from "@/sections/layouts/IntroContent"

export const Route = createFileRoute("/$sessionId/_session/intro/")({
  component: IntroRoute,
})

function IntroRoute() {
  const { sessionId } = Route.useParams()

  return (
    <IntroContent
      aboveHeading={<WallGraphic type="Requirements" />}
      activeStepIndex={0}
      numberOfSteps={5}
      linkProps={{ to: "/$sessionId/intro/welcome", params: { sessionId } }}
      heading={{
        i18nKey: "intro.requirements.heading",
      }}
      descriptionNode={
        <ul className="list-disc pl-5">
          {[1, 2, 3].map((i) => {
            return (
              <Text as="li" key={i}>
                <Trans i18nKey={`intro.requirements.item${i}`} />
              </Text>
            )
          })}
        </ul>
      }
    />
  )
}
